import styled from 'styled-components';
import { Icon } from 'components/common';

export const HeaderIcon = styled(Icon)`
  font-size: 16px !important;
`;

export const TwoLineLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const CenterItem = styled.div`
  text-align: center;
  width: 100%;
`;
